/*
 * Apollo Link to make sure our requests have re-try functionality in case of request failure
 * Docs: https://www.apollographql.com/docs/link/links/retry.html
 */
import { RetryLink } from 'apollo-link-retry';

export const EXPONENTIAL_BACKOFF_RETRY_POLICY = {
	INITIAL_DELAY: 200,
	MAX_RETRIES: 5,
	JITTER: true,
};

export function is5xx(status: number) {
	return 500 <= status && status <= 599;
}

export const createRetryLink = (retryOptions: RetryLink.Options) =>
	new RetryLink({
		delay: {
			initial: EXPONENTIAL_BACKOFF_RETRY_POLICY.INITIAL_DELAY,
			max: Infinity,
			jitter: EXPONENTIAL_BACKOFF_RETRY_POLICY.JITTER,
			...retryOptions.delay,
		},
		attempts: {
			max: EXPONENTIAL_BACKOFF_RETRY_POLICY.MAX_RETRIES,
			retryIf: (error, operation) => {
				const context = operation.getContext();
				const response = context.response as Response;
				const noRetry = context.noRetry as boolean | undefined;

				return is5xx(response && response.status) && !noRetry;
			},
			...retryOptions.attempts,
		},
	});
